import { ElementRef, InjectionToken } from '@angular/core';
import { z } from 'zod';

export const TL_GRAPH_RATES_URL = new InjectionToken<string>(
    'TL_GRAPH_RATES_URL',
);
export const TRENDLINES_CACHE_DB = 'trendlines-cache';
export const TRENDLINES_GRAPH_RATES_VAN_DOC = 'trendlines_graph_rates_van_doc';
export const TRENDLINES_GRAPH_RATES_REEFER_DOC =
    'trendlines_graph_rates_reefer_doc';
export const TRENDLINES_GRAPH_RATES_FLATBED_DOC =
    'trendlines_graph_rates_flatbed_doc';

export const RateSchema = z.object({
    date: z.date(),
    rate: z.number(),
});

export const ForecastBannerText = 'Subscribe to RateView to unlock forecasting';

export const UpsellTrackingEventName = 'Clicked To Learn More - iQ Upsell';

export type Rate = z.infer<typeof RateSchema>;

export type RateMap = {
    spot: Rate[];
    contract: Rate[];
};

export interface IIqTrendlinesGraphRatesStateService {
    flatbedGraph(container: ElementRef, rateMap: RateMap): void;
    reeferGraph(container: ElementRef<any>, rateMap: RateMap): void;
    vanGraph(container: ElementRef<any>, rateMap: RateMap): void;
    vanData(): Promise<RateMap>;
    reeferData(): Promise<RateMap>;
    flatbedData(): Promise<RateMap>;
}
